import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DisplayOptions } from '../../../shared/interfaces/display-options';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { Router } from '@angular/router';
import { NoDataActionType } from '../../../shared/interfaces/no-data';
import { IPageHeadline } from '../../../shared/classes/page-title-parameters';
import { CustomDashboardsOutletDirective } from '../../../my-limegear/my-limegear-outlet.directive';
import { CustomDashboardsService } from '../../../my-limegear/services/my-limegear.service';
import { ComponentsOutletDirectiveService } from '../../../my-limegear/services/component-outlet-directive.service';

@Component({
    selector: 'leads-partners',
    templateUrl: './leads-partners.component.html',
    styleUrls: ['./leads-partners.component.scss'],
})
export class LeadsPartnersComponent implements OnInit {
    displayOptions: DisplayOptions[];
    hFilterJSON: string;
    pageHeadline: IPageHeadline;
    action: NoDataActionType;
    selectSummaryHideList: DisplayOptions[] = [];
    smallCardIdArray: Array<string>;
    largeCardIdArray: Array<string>;
    dashboard = 'leads-partners';

    constructor(
        private _router: Router,
        private reusableFunctions: ReusableFunctions,
        private cd: ChangeDetectorRef,
        private customDashboardsService: CustomDashboardsService,
        private componentsOutletDirectiveService: ComponentsOutletDirectiveService
    ) {}

    @ViewChildren(CustomDashboardsOutletDirective) dashboardOutlet: QueryList<
        CustomDashboardsOutletDirective
    >;

    ngOnInit() {
        this.pageHeadline = {
            linkTitle: 'Leads & Partners Home',
            module: 'leads-partners',
            moduleIcon: 'fa-handshake',
            moduleLink: 'leads-partners',
            pageTitle: 'Leads & Partners At a Glance',
        };

        this.customDashboardsService.detectChange(
            '',
            [],
            false,
            false,
            NoDataActionType.pageStart,
            this.dashboard
        );

        this.smallCardIdArray = [
            'totalLeads',
            'applicationsFromLeads',
            'leadToAppConversion',
            'fundedFromLeads',
            'leadToFundConversion',
        ];

        this.largeCardIdArray = ['leadSources', 'realEstateBuyerAgents'];
        this.displayOptions = this.reusableFunctions.getCurrentDisplayOptions(this._router.url);
        let dateRangeOption = this.displayOptions.find((x) => x.optionKey == 'dateRange_y_q_m');
        if (dateRangeOption) {
            this.selectSummaryHideList.push(dateRangeOption);
        }

        this.updateComponent();
    }

    updateComponent() {
        this.componentsOutletDirectiveService.detectViewChanges(this.cd);
        this.componentsOutletDirectiveService.loadContents(this.dashboardOutlet);
    }

    applyNewFilters(event: string) {
        this.hFilterJSON = event;
        this.action = NoDataActionType.filter;
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            true,
            false,
            NoDataActionType.filter,
            this.dashboard
        );
        this.updateComponent();
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.displayOptions = event;
        this.action = NoDataActionType.filter;
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            false,
            true,
            NoDataActionType.filter,
            this.dashboard
        );
        this.updateComponent();
    }

    ngOnDestroy() {
        this.customDashboardsService.unsubscribeFilters();
    }
}
